module.exports = __webpack_public_path__ + "static/media/heart_outline.4fbb913a.svg";